import React from 'react';
import { Box, Typography, Card, CardActionArea, CardMedia, CardContent, useTheme, useMediaQuery } from '@mui/material';
import { FaCalendarAlt } from 'react-icons/fa';
import { Link as RouterLink } from 'react-router-dom';
import { successStories } from '../../utils/BeadsData';
import { formatDateSimple } from '../../utils/dateUtils';


const SidebarSuccessStories = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ my: 5, mx: isMobile ? 'auto' : 2, border: '1px solid #cfcfcf', borderRadius: '1rem', overflow: 'hidden' }}>
            <Box sx={{
                position: 'relative',
                color: '#f39c12',
                typography: 'h6',
                fontWeight: 'bold',
                my: 2,
                textAlign: 'center'
            }}>
                Other success Stories
                <Box sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: '10%',
                    width: '80%',
                    height: '3px',
                    backgroundImage: 'linear-gradient(to right, #f39c12, #f39c12 50%, #cdcfd2 50%)',
                }} />
            </Box>
            {successStories.map((story, index) => (
                <Card key={index} sx={{ display: 'flex', m: 2, borderRadius: '1rem', transition: '0.3s', '&:hover': { bgcolor: '#white' } }}>
                    <CardActionArea component={RouterLink} to={story.link} sx={{ display: 'flex', alignItems: 'center' }}>
                        <CardMedia
                            component="img"
                            image={story.image}
                            alt={story.alt}
                            sx={{ width: 120, height: 120, borderRadius: '.8rem', m: 1 }}
                        />
                        <CardContent sx={{ flex: '1', '&:last-child': { paddingBottom: '16px' } }}>
                            <Typography gutterBottom variant="body2" component="div" sx={{ fontSize: '0.875rem', '&:hover': { color: '#f39c12' }, transition: 'color 0.3s' }}>
                                {story.title}
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
                                <FaCalendarAlt style={{ marginRight: 4, fontSize: '0.8rem' }} />
                                <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                                    {formatDateSimple(story.date)}
                                </Typography>
                            </Box>
                        </CardContent>
                    </CardActionArea>
                </Card>
            ))}
        </Box>
    );
};

export default SidebarSuccessStories;
